import { Controller } from "@hotwired/stimulus";

// GR-3355: the Request Context sidebar lists the AV the request asked for, and
// each row can put itself on the quote as a line.
//
// The sidebar is outside the form, so it cannot reach the line-item controller
// through the DOM. It says what was asked for and the form's own controller
// writes the row, which keeps one mechanism for adding a line rather than two,
// and leaves the row markup in the view where it belongs.
export default class AvQuoteLinesController extends Controller {
  add({ params }) {
    this.dispatch("add", {
      target: document,
      detail: {
        description: params.description,
        quantity: params.quantity,
        unitPrice: params.unitPrice,
        category: params.category,
      },
    });
  }
}
